import React from 'react';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';

export default function ReadInventory(props) {
  const { dataProduct } = props;

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 style={{ color: 'black' }}>Datos</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <h6>Fijar cuenta de mayor según</h6>
              <p>
                {dataProduct.GLMethod == 'C'
                  ? 'Grupo de artículos'
                  : dataProduct.GLMethod == 'W'
                  ? 'Almacén'
                  : dataProduct.GLMethod == 'L'
                  ? 'Nivel artículo'
                  : '-'}
              </p>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <h6>Método de valorización</h6>
              <p>
                {dataProduct.EvalSystem == 'A'
                  ? 'Promedio ponderado'
                  : dataProduct.EvalSystem == 'S'
                  ? 'Estándar'
                  : dataProduct.EvalSystem == 'F'
                  ? 'Fijo'
                  : '-'}
              </p>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <h6>Unidad de medida</h6>
              <p>{dataProduct.Invntryuom}</p>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <h6>Inventariable</h6>
              <p>
                {dataProduct.InvntItem == 'Y' ? 'Si' : dataProduct.InvntItem == 'N' ? 'No' : '-'}
              </p>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <h6>Stock x almacén</h6>
              <p>{dataProduct.Bywh == 'Y' ? 'Si' : dataProduct.Bywh == 'N' ? 'No' : '-'}</p>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
  );
}
